import { render, staticRenderFns } from "./guestFeatureRequest.vue?vue&type=template&id=21b90a78&scoped=true&"
import script from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
export * from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
import style0 from "./guestFeatureRequest.vue?vue&type=style&index=0&id=21b90a78&lang=scss&scoped=true&"
import style1 from "./guestFeatureRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b90a78",
  null
  
)

export default component.exports